/**
 * Campos de uma lista estruturada vêm da configuração do tipo de registro:
 * o formulário não conhece os campos, só o tipo de cada um. A largura sai
 * daí — hora e número ocupam pouco, texto longo ocupa a linha inteira.
 */
export const FIELD_TYPES = ['text', 'textarea', 'select', 'number', 'time', 'date'];

const COLUMN_BY_TYPE = {
  time: 'col-6 col-md-3',
  date: 'col-6 col-md-3',
  number: 'col-6 col-md-3',
  select: 'col-12 col-md-6',
  text: 'col-12 col-md-6',
  textarea: 'col-12',
};

const DEFAULT_ROWS = 3;

function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

function optionsOf(field) {
  if (!Array.isArray(field?.options)) return [];

  return field.options
    .map((option) => (option && typeof option === 'object'
      ? String(option.label ?? option.value ?? '')
      : String(option ?? '')))
    .filter((option) => option !== '');
}

function boolOf(value) {
  return value === true || value === 1 || value === '1';
}

export function normalizeField(field) {
  const type = FIELD_TYPES.includes(field?.type) ? field.type : 'text';
  const explicitColumn = Number(field?.col);
  const hasExplicitColumn = Number.isInteger(explicitColumn)
    && explicitColumn >= 1
    && explicitColumn <= 12;

  return {
    key: String(field?.key ?? ''),
    label: String(field?.label ?? field?.key ?? ''),
    type,
    options: optionsOf(field),
    columnClass: hasExplicitColumn
      ? `col-12 col-md-${explicitColumn}`
      : COLUMN_BY_TYPE[type],
    rows: type === 'textarea' ? clamp(Number(field?.rows) || DEFAULT_ROWS, 2, 8) : null,
    placeholder: String(field?.placeholder ?? ''),
    required: boolOf(field?.required),
  };
}

export function normalizeFields(fields) {
  if (!Array.isArray(fields)) return [];

  return fields
    .filter((field) => field && field.key)
    .map(normalizeField);
}

/** Rótulos dos campos obrigatórios que ficaram em branco. */
export function missingRequired(fields, values) {
  return fields
    .filter((field) => field.required)
    .filter((field) => String(values?.[field.key] ?? '').trim() === '')
    .map((field) => field.label);
}
